var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.08665C14.3126 7.08665 14.622 7.14821 14.9108 7.26782C15.1996 7.38743 15.4619 7.56273 15.6829 7.78374C15.9039 8.00474 16.0792 8.26711 16.1988 8.55587C16.3185 8.84462 16.38 9.15411 16.38 9.46665C16.38 9.7792 16.3185 10.0887 16.1988 10.3774C16.0792 10.6662 15.9039 10.9286 15.6829 11.1496C15.4619 11.3706 15.1996 11.5459 14.9108 11.6655C14.622 11.7851 14.3126 11.8467 14 11.8467C13.3688 11.8467 12.7634 11.5959 12.3171 11.1496C11.8708 10.7032 11.62 10.0979 11.62 9.46665C11.62 8.83544 11.8708 8.23007 12.3171 7.78374C12.7634 7.3374 13.3688 7.08665 14 7.08665ZM14 17.2867C17.366 17.2867 20.9134 18.9413 20.9134 19.6667V20.9133H7.08668V19.6667C7.08668 18.9413 10.634 17.2867 14 17.2867ZM14 4.93332C11.4953 4.93332 9.46668 6.96199 9.46668 9.46665C9.46668 11.9713 11.4953 14 14 14C16.5047 14 18.5333 11.9713 18.5333 9.46665C18.5333 6.96199 16.5047 4.93332 14 4.93332ZM14 15.1333C10.974 15.1333 4.93335 16.652 4.93335 19.6667V23.0667H23.0667V19.6667C23.0667 16.652 17.026 15.1333 14 15.1333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.9633621f91e350b104f24bfc2602eabf.svg";
export { ForwardRef as ReactComponent };